/* ===== Slider Video Thumbnail Play/Pause ===== */
$(document).off("click.videoToggle", ".rc-js-video").on("click.videoToggle", ".rc-js-video", function (e) {
  e.preventDefault();
  e.stopPropagation();
  if (this.paused) {
    this.play();
    $('.rc-video-play-button').addClass('is-hide');
  } else {
    this.pause();
    $('.rc-video-play-button').removeClass('is-hide');
  }
});

/* ===== DROPDOWN HANDLER ===== */
document.addEventListener("click", function (e) {
  const trigger = e.target.closest(".custom-dropdown__trigger");
  if (trigger) {
    const currentDropdown = trigger.parentElement;
    const isAlreadyOpen = currentDropdown.classList.contains("is-open");
    document.querySelectorAll(".custom-dropdown.is-open").forEach((dd) => dd.classList.remove("is-open"));
    if (!isAlreadyOpen) currentDropdown.classList.add("is-open");
    return;
  }
  const option = e.target.closest(".custom-dropdown__option");
  if (option) {
    const dropdown   = option.closest(".custom-dropdown");
    const selectId   = dropdown.dataset.selectId;
    const select     = document.getElementById(selectId);
    const value      = option.dataset.value;

    if (select) select.value = value;
    if (select) select.dispatchEvent(new Event("change", { bubbles: true }));

    dropdown.querySelectorAll(".custom-dropdown__option").forEach((btn) => btn.classList.remove("is-active"));
    option.classList.add("is-active");

    // Sync visible trigger label with whatever was actually clicked
    const label = dropdown.querySelector(".custom-dropdown__label");
    if (label) label.textContent = option.textContent.trim();

    dropdown.classList.remove("is-open");

    const url = option.dataset.url;
    if (url && url.trim() !== "") {
      window.location.href = url;
    }
    return;
  }
  document.querySelectorAll(".custom-dropdown.is-open").forEach((dd) => dd.classList.remove("is-open"));
});

/* ===== VIDEO PLAY BUTTON ===== */
$(document).on('click', '.rc-video-play-button', function () {
  const $btn = $(this);
  const $container = $btn.closest('.product-media-container');
  const deferred = $container.find('deferred-media')[0];

  if (!deferred) {
    console.warn('rc-video: no deferred-media found');
    return;
  }

  // Get live video (not inside <template>)
  function getLiveVideo() {
    return Array.from(deferred.querySelectorAll('video.rc-js-video'))
      .find(v => !v.closest('template'));
  }

  function bindAndPlay(video) {
    video.play().catch(e => console.warn('play failed:', e));
    $btn.addClass('is-hide');

    // Bind click-to-toggle directly on video (only once)
    if (!video.dataset.rcBound) {
      video.dataset.rcBound = '1';
      video.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (this.paused) {
          this.play();
          $btn.addClass('is-hide');
        } else {
          this.pause();
          $btn.removeClass('is-hide');
        }
      });
    }
  }

  // Case 1: already live in DOM
  const existing = getLiveVideo();
  if (existing) {
    bindAndPlay(existing);
    return;
  }

  // Case 2: stamp out the <template>
  const template = deferred.querySelector('template');
  if (!template) {
    console.warn('rc-video: no <template> inside deferred-media');
    return;
  }

  const clone = document.importNode(template.content, true);
  deferred.appendChild(clone);
  deferred.setAttribute('loaded', 'true');

  requestAnimationFrame(() => {
    const newVideo = getLiveVideo();
    if (newVideo) {
      bindAndPlay(newVideo);
    } else {
      console.warn('rc-video: video still not found after stamping template');
    }
  });
});

/* ===== SLIDER OBSERVER — pause + reset on slide leave ===== */
if (window.rcSliderObserver) window.rcSliderObserver.disconnect();

window.rcSliderObserver = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (mutation.type !== 'attributes' || mutation.attributeName !== 'class') return;
    const slide = mutation.target;
    if (slide.classList.contains('active')) return;

    const video = Array.from(slide.querySelectorAll('video.rc-js-video'))
      .find(v => !v.closest('template'));
    const btn = slide.querySelector('.rc-video-play-button');

    if (video) {
      video.pause();
      video.currentTime = 0;
    }
    if (btn) btn.classList.remove('is-hide');
  });
});

document.querySelectorAll('.slider-slide').forEach((slide) => {
  window.rcSliderObserver.observe(slide, { attributes: true });
});

/* ===== SHARED: Get Ring_Size from URL ===== */
function rcGetRingSizeFromUrl() {
  return new URLSearchParams(window.location.search).get('Ring_Size') || '';
}

/* ===== SHARED: Build select-diamond URL (single source of truth) ===== */
function rcBuildSelectDiamondUrl(shape, variant, handle) {
  let url = `/pages/select-diamond?shapes=${encodeURIComponent(shape)}&variant=${variant}&handle=${handle}`;
  // Pass Ring_Size along to the diamond selection page
  const ringSize = rcGetRingSizeFromUrl();
  if (ringSize) url += `&Ring_Size=${encodeURIComponent(ringSize)}`;
  // Pass Start with setting along to the diamond selection page
  const isStartWithSetting = new URLSearchParams(window.location.search).get('start-with-setting') || '';
  if (isStartWithSetting) url += `&start-with-setting=${encodeURIComponent(isStartWithSetting)}`;
  // Pass allowed shapes from product to bespoke feed
  if (window.RC_RING_PRODUCT_SHAPES && window.RC_RING_PRODUCT_SHAPES.length) {
    url += `&allowed_shapes=${encodeURIComponent(window.RC_RING_PRODUCT_SHAPES.join(','))}`;
  }
  try {
    const storedDiamond = localStorage.getItem('rc_selected_diamond');
    if (storedDiamond) {
      const diamond = JSON.parse(storedDiamond);
      if (diamond?.cert_num) url += `&cert=${diamond.cert_num}`;
    }
  } catch (e) {}
  return url;
}

/* ===== SHARED: Redirect to select-diamond ===== */
function rcRedirectToSelectDiamond(shape, variant, handle) {
  window.location.href = rcBuildSelectDiamondUrl(shape, variant, handle);
}

/* ===== SELECT SETTING CTA — disable by default, enable when ring size chosen ===== */
document.addEventListener('DOMContentLoaded', function () {
  const selectBtn = document.getElementById('js-bespoke-select-setting');
  const reviewBtn = document.getElementById('js-bespoke-review-your-design');
  const ringSize = rcGetRingSizeFromUrl();

  if (!ringSize) {
    if (selectBtn) {
      selectBtn.disabled = true;
      selectBtn.classList.add('is-disabled');
    }
    if (reviewBtn) {
      reviewBtn.disabled = true;
      reviewBtn.classList.add('is-disabled');
    }
  }
});

/* ===== SELECT SETTING CTA click ===== */
document.getElementById('js-bespoke-select-setting')?.addEventListener('click', function () {
  rcSaveSelectedSetting(this);
  rcRedirectToSelectDiamond(this.dataset.shape, this.dataset.variant, this.dataset.handle);
});

/* ===== CHANGE Setting link (pre-cart) ===== */
document.querySelector('.rc-pre-cart-change-setting')?.addEventListener('click', function (e) {
  e.preventDefault();
  const btn = document.getElementById('js-bespoke-select-setting');
  rcRedirectToSelectDiamond(
    btn?.dataset.shape,
    btn?.dataset.variant,
    btn?.dataset.handle
  );
});

/* ===== REVIEW YOUR DESIGN CTA ===== */
document.getElementById('js-bespoke-review-your-design')?.addEventListener('click', function () {
  rcSaveSelectedSetting(this);
  const url = new URL(window.location.href);
  url.searchParams.set('is_pre_cart', 'true');
  // Ensure variant is in the URL — fallback to data-variant on the button
  if (!url.searchParams.get('variant')) {
    url.searchParams.set('variant', this.dataset.variant);
  }
  window.location.href = url.toString();
});

/* ===== SHARED: Save selected setting to localStorage ===== */
function rcSaveSelectedSetting(btn) {
  try {
    const price = btn.dataset.price;
    const priceFormatted = '$' + Math.round(parseInt(price) / 100).toLocaleString();

    localStorage.setItem('rc_selected_setting', JSON.stringify({
      title:      btn.dataset.title,
      price:      priceFormatted,
      handle:     btn.dataset.handle,
      variant_id: btn.dataset.variant,
      url:        window.location.href
    }));
  } catch (e) {}
}

/* ===== IF DIAMOND SELECTED: Swap shape picker with summary + swap CTAs ===== */
document.addEventListener('DOMContentLoaded', function () {
  const storedRaw = localStorage.getItem('rc_selected_diamond');
  if (!storedRaw) return;

  let diamond;
  try { diamond = JSON.parse(storedRaw); } catch (e) { return; }
  if (!diamond) return;

  const shapePicker = document.querySelector('.rc-diamond-shape-options')?.closest('fieldset');
  if (!shapePicker) return;

  const carat   = parseFloat(diamond.size || 0).toFixed(2);
  const shape   = diamond.shape || '';
  const color   = diamond.color || '';
  const clarity = diamond.clarity || '';
  const cut     = diamond.cut || diamond.cut_grade || 'Excellent';
  const price   = diamond.marked_up_price || diamond.total_sales_price || 0;

  const summaryEl = document.createElement('div');
  summaryEl.className = 'rc-selected-diamond-summary';
  summaryEl.innerHTML = `
    <span class="rc-selected-diamond-summary-value"><span class="rc-bespoke-pdp-sel-diamond-txt">Your Diamond:</span> ${shape} ${carat}ct, ${color}, ${clarity}, ${cut} $${Number(price).toLocaleString()}</span>
  `;

  shapePicker.replaceWith(summaryEl);

  document.getElementById('js-bespoke-select-setting')
    ?.closest('.rc-bespoke-select-setting-cta')
    ?.style.setProperty('display', 'none');

  document.getElementById('js-bespoke-review-your-design')
    ?.closest('.rc-bespoke-select-setting-cta')
    ?.classList.remove('is-hide');
});

/* ===== PRESERVE Ring_Size on variant change ===== */
(function () {
  const _replaceState = history.replaceState.bind(history);
  history.replaceState = function (state, title, url) {
    if (url) {
      const newUrl = new URL(url, window.location.origin);
      const ringSize = new URLSearchParams(window.location.search).get('Ring_Size');
      if (ringSize && !newUrl.searchParams.has('Ring_Size')) {
        newUrl.searchParams.set('Ring_Size', ringSize);
      }
      return _replaceState(state, title, newUrl.toString());
    }
    return _replaceState(state, title, url);
  };
})();